import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PxDownloadLinkConfigService } from '../config/px-download-link-config.service';
import { Observable } from 'rxjs';
import { PxUploadResponse } from '../models';

export interface IPxUploadService {
    upload(formData: FormData, path: string): Observable<HttpEvent<PxUploadResponse>>;

    delete(path: string): Observable<void>;

    status(path: string): Observable<any>;
}

@Injectable({
    providedIn: 'root',
})
export class PxUploadService implements IPxUploadService {
    constructor(private httpClient: HttpClient, private config: PxDownloadLinkConfigService) {}

    public upload(formData: FormData, path: string) {
        return this.httpClient.post<any>(`${this.config.apiHost}${path}`, formData, {
            reportProgress: true,
            observe: 'events',
        });
    }

    public delete(path: string) {
        return this.httpClient.delete<void>(`${this.config.apiHost}${path}`);
    }

    public status(path: string) {
        return this.httpClient.get<any>(`${this.config.apiHost}${path}`);
    }
}
